import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { IRouteReducerSliceStateInit } from "../slice_interface";
import {
  ICertificateDocumentListResponseData,
  ICertificatesDocumentUploadPostBody,
} from "@/api_framework/api_modals/Certificates";

export interface ICertificateState {
  documentList: ICertificateDocumentListResponseData;
  documentUpload: ICertificatesDocumentUploadPostBody;
}
export interface ICertificateInitialState extends IRouteReducerSliceStateInit {
  state: ICertificateState;
}

const initialState: ICertificateInitialState = {
  state: {
    documentList: null,
    documentUpload: null,
  },
};

const certificateSlice = createSlice({
  name: "certificate_slice",
  initialState: initialState,
  reducers: {
    // RESET_INVENTORY: () => {
    //   return initialState;
    // },
    setDocumentList: (
      state,
      action: PayloadAction<{
        data: ICertificateDocumentListResponseData;
      }>,
    ) => {
      state.state.documentList = action.payload.data;
    },
    setDocumentUpload: (
      state,
      action: PayloadAction<{
        data: ICertificatesDocumentUploadPostBody;
      }>,
    ) => {
      state.state.documentUpload = action.payload.data;
    },
  },
});

export const { setDocumentList, setDocumentUpload } = certificateSlice.actions;
export default certificateSlice.reducer;
